import { apiFetch } from '../utils/api';

export interface ProductTemplate {
  id: string;
  erpId: number;
  name: string;
  description: string | null;
  attributes?: Array<{
    id: string;
    name: string;
    erpId: number;
    defaultValue: string | null;
    options: string[];
  }>;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedTemplatesResponse {
  data: ProductTemplate[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const fetchProductTemplates = (params: {
  page?: number;
  limit?: number;
  search?: string;
} = {}): Promise<PaginatedTemplatesResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.search) {
    searchParams.set('search', params.search);
  }

  const query = searchParams.toString();
  return apiFetch<PaginatedTemplatesResponse>(
    `/product/templates${query ? `?${query}` : ''}`,
  );
};

export const fetchProductTemplate = (id: string) =>
  apiFetch<ProductTemplate>(`/product/templates/${id}`);
